import React, { Component }  from 'react'
import { Icon, Modal, Button } from 'semantic-ui-react'
import FileInput from '../../components/FileInput/FileInput'

class GradesReadCSV extends Component {
  render() {
    return (
      <Modal
        trigger={
          <Button icon labelPosition='right' color='green'> <Icon name='upload' />
          Import Grades
          </Button>
        }
        closeIcon
        >
        <Modal.Header>Import Grades</Modal.Header>
        <Modal.Content>
            <FileInput
              handleFileChange={this.props.handleFileChange}
              className='grades-file-input'
              error={false}
            />
        </Modal.Content>
        <Modal.Actions>
          <Button color='green' onClick={this.props.handleDataSave}>
            <Icon name='checkmark' /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
};

export default GradesReadCSV;
